var SV_ES = ((document.documentElement && document.documentElement.lang) || '').slice(0, 2) === 'es';
(function () {
  if (window.snusventaProductCardsGlobalLoaded) return;
  window.snusventaProductCardsGlobalLoaded = true;

  function formatSnusVentaMoney(cents, currency, locale) {
    const amount = Number(cents || 0) / 100;

    try {
      return new Intl.NumberFormat(locale || undefined, {
        style: 'currency',
        currency: currency || 'EUR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(amount);
    } catch (error) {
      return '€' + amount.toFixed(2);
    }
  }

  function updateSnusVentaCard(card, packButton) {
    if (!card || !packButton) return;

    const form = card.querySelector('[data-sv-card-form]');
    const quantityInput =
      card.querySelector('[data-sv-quantity-input]') ||
      card.querySelector('input[name="quantity"]');

    const totalPrice = card.querySelector('[data-sv-total-price]');
    const unitPrice = card.querySelector('[data-sv-unit-price]');

    if (!form || !quantityInput || !totalPrice || !unitPrice) return;

    const quantity = Number(packButton.dataset.packSize || packButton.dataset.qty || 1);
    const discount = Number(packButton.dataset.discount || 0);
    const baseUnitPrice = Number(form.dataset.unitPrice || totalPrice.dataset.unitPrice || 0);
    const currency = form.dataset.currency || 'EUR';
    const locale = form.dataset.locale || undefined;

    const total = Math.round(baseUnitPrice * quantity * (100 - discount) / 100);
    const unit = Math.round(total / quantity);

    quantityInput.value = quantity;
    totalPrice.textContent = formatSnusVentaMoney(total, currency, locale);
    unitPrice.textContent = formatSnusVentaMoney(unit, currency, locale) + (SV_ES ? '/lata' : '/can');
  }

  function initSnusVentaCards(root) {
    const scope = root || document;

    scope.querySelectorAll('[data-sv-product-card]').forEach(function (card) {
      const activeButton =
        card.querySelector('.sv-pack-button.is-active[data-pack-size]') ||
        card.querySelector('.sv-pack-button.is-active[data-qty]');

      if (activeButton) {
        updateSnusVentaCard(card, activeButton);
      }
    });
  }

  document.addEventListener('click', function (event) {
    const packButton = event.target.closest('.sv-pack-button[data-pack-size], .sv-pack-button[data-qty]');
    if (!packButton || packButton.disabled) return;

    const card = packButton.closest('[data-sv-product-card]');
    if (!card) return;

    card.querySelectorAll('.sv-pack-button[data-pack-size], .sv-pack-button[data-qty]').forEach(function (button) {
      const isActive = button === packButton;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    updateSnusVentaCard(card, packButton);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initSnusVentaCards(document);
    });
  } else {
    initSnusVentaCards(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initSnusVentaCards(event.target);
  });

  document.addEventListener('shopify:section:reorder', function (event) {
    initSnusVentaCards(event.target);
  });

  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (!(node instanceof HTMLElement)) return;

        if (node.matches('[data-sv-product-card]') || node.querySelector('[data-sv-product-card]')) {
          initSnusVentaCards(node);
        }
      });
    });
  });

  if (document.body) {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})();